import { Language } from 'src/interface';
import { resourcesRU } from './resources/ru';
import { resourcesEN } from './resources/en';

export const resources = {
  [Language.RU]: resourcesRU,
  [Language.EN]: resourcesEN,
};
